export default __webpack_public_path__ + "atomic/_patterns/01-atoms/secondary-menu-link/_secondary-menu-link.twig";